import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from "../../NotFound/NotFound";
import CtrStepperPages from "./scenes/CtrStepperPages";

const rp = RouterPath.ctrDemand;

function CtrDemand() {

    return (
        <Switch>
            {/*zmiana */}
            <Redirect exact from={rp.old.CTR_DEMAND_CORRESPONDENCE_ID} to={rp.steps.CTR_DEMAND_ID_CORRESPONDENCE} />
            <Redirect exact from={rp.steps.CTR_DEMAND_ID} to={rp.steps.CTR_DEMAND_ID_OFFER_STAGE} />
            <Redirect exact from={rp.steps.CTR_DEMAND_ID_OFFER} to={rp.steps.CTR_DEMAND_ID_OFFER_STAGE} />


            <Route exact path={rp.steps.CTR_DEMAND_ID_CORRESPONDENCE} component={CtrStepperPages}/>
            <Route exact path={rp.steps.CTR_DEMAND_ID_OFFER_STAGE} component={CtrStepperPages}/>
            <Route exact path={rp.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION} component={CtrStepperPages}/>
            <Route exact path={rp.steps.CTR_DEMAND_ID_OFFER_STAGE_ID} component={CtrStepperPages}/>


            <Route component={NotFound}/>
        </Switch>
    )
}

export default CtrDemand;
